import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { CARRIER } from '@Builder/QuoteDetailPage/QuoteDetailsSummaryCard/components/ShippingSection/constants'

import { getUserIdentity } from '~/redux-modules/identity'
import { stateType as UserDetailsStateType } from '~/redux-modules/user-details/types'

type ParamsType = {
    id?: string
    quoteId?: string
    userId?: string
}

export const useGetIncludePdfInput = ({
    carrierAccountId,
    priceInput,
    selectedAddressId,
    selectedShippingOption,
}: {
    carrierAccountId?: string
    priceInput?: any
    selectedAddressId?: number | string
    selectedShippingOption?: any
}) =>
    useMemo(() => {
        // priceInput is from checkout page
        if (priceInput) {
            const priceInputCopy = {
                ...priceInput,
                isShippingOptionForCarrier: Boolean(
                    priceInput?.carrierAccountId,
                ),
            }

            delete priceInputCopy.quoteId
            return priceInputCopy
        }
        const shippingMethods: { token: string; addressId: number }[] = []

        if (selectedShippingOption && selectedAddressId) {
            shippingMethods.push({
                token: selectedShippingOption.quoteToken,
                addressId: parseInt(selectedAddressId as string),
            })
        }
        return {
            carrierAccountId,
            discounts: [], // discounts is required for shareQuoteMutation, but only checkout page can pass it
            shippingMethods,
            isShippingOptionForCarrier: (
                selectedShippingOption?.id || ''
            ).startsWith(CARRIER),
        }
    }, [
        carrierAccountId,
        priceInput,
        selectedAddressId,
        selectedShippingOption,
    ])

export const useGetCarrierAccountId = (state: UserDetailsStateType) => {
    const { id, quoteId, userId } = useParams<ParamsType>()
    const identity = getUserIdentity(state)

    const currQuoteId = id || quoteId
    const currUserId = userId || identity?.id

    return currQuoteId
        ? state.userDetails?.[currUserId]?.defaultCarrierId
        : undefined
}
